// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3rn15","bg":"_2Ssvs","hbox":"_12E_4","htxt":"_2fApV","ptxt":"_21VyE","numBox":"_2IDH2","break":"_1tM2X","strongnum":"_2hZ1k","circles":"_2oWhz","circle1":"_2tgBm _2oWhz","fadeInFromNone":"_2pD1v","circle2":"_1DLy4 _2oWhz","circle3":"_3ky7v _2oWhz","ctxt":"_3xdpn"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Header/Header.scss
 ** module id = 447
 ** module chunks = 0
 **/